/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["[_nghost-%COMP%]{display:block;margin-left:auto;margin-right:auto;padding-left:8px;padding-right:8px}"];
export { styles as styles };

